// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Order_item_requests_ConfirmarSaidaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/order_item_requests/confirmar_saida/{id}
 *
 * Mark a customer request as confirmed-on-exit. The id arrives as a URI
 * segment; the body carries the foto-depois URL that proves the request
 * was actually fulfilled.
 */
import { registerContract } from './validate'

export interface Order_item_requests_ConfirmarSaidaInput {
exit_photo?: string
}

registerContract('Order_item_requests_ConfirmarSaidaInput', {
  exit_photo: { type: 'string',  required: false },
})
